/* eslint-disable react/jsx-props-no-spreading */
import { jobDetailType, reqObjType } from "src/components/common/MainContent/JobResults/common";
import clsx from "clsx";
import config from "src/config";
import { v4 as uuidv4 } from "uuid";
import { Skeleton } from "@mui/material";
import { useState } from "react";
import { withTranslation } from "react-i18next";
import { postJobApplicationFavoriteEmail } from "src/redux/userAction/applyFavEmail/action";
import { connect } from "react-redux";
import styles from "./JobCardHeader.module.scss";
import JobCardChip, { JobCardChipProps } from "../chip/JobCardChip";
import EmailAndFavoriteIcons from "../email-and-favorite-icons/EmailAndFavoriteIcons";

const imageUrl = config.JOB_CARD_IMAGE_URI_DOMAIN;

export interface JobCardHeaderProps {
  job?: jobDetailType;
  chips?: JobCardChipProps[];
  showContactAction?: boolean;
  showFavoriteAction?: boolean;
  allJobs: any;
  jobDetails: any;
  similarJobs: any;
  collaboratedJobs: any;
  myJobs: any;
  recommendedJobs: any;
  recommended?: boolean;
  isRecommendedJobsOnResult?: boolean;
  similarOrViewed?: string;
  viewMyJobs?: boolean;
  className?: string;
  error: boolean;
  emailSuccess: boolean;
  emailSuccessResponse: {
    appliedJobId: string;
    message: string;
    status: number;
    statusCode: string;
  };
  actionJobId: string;
  sourceType: string;
  campaignCode: string;
  postTheJobApplicationFavoriteEmail: (reqObj: reqObjType & { jobId: string }) => void;
  onEmailClick: () => void;
  onClick?: () => void;
  modifyJob?: (partialJob: Partial<jobDetailType>) => void;
}

const JobCardHeader = ({
  job,
  chips,
  showContactAction,
  showFavoriteAction,
  recommended,
  isRecommendedJobsOnResult,
  similarOrViewed,
  viewMyJobs,
  className,
  sourceType,
  campaignCode,
  onEmailClick,
  onClick,
  modifyJob
}: JobCardHeaderProps) => {
  const [isImageBroken, setIsImageBroken] = useState<boolean>(false);

  if (job == null) {
    return (
      <div className={clsx(styles.main, className, styles.noBackground)}>
        <Skeleton variant="rectangular" width="100%" height={140} />
      </div>
    );
  }

  const image =
    isImageBroken || job.imageUri == null
      ? "https://d308dt1i66cme4.cloudfront.net/content/images/facility/default/default.jpg"
      : `${imageUrl}${job.imageUri}`;

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={() => onClick?.()}
      onClick={() => onClick?.()}
      data-testid={`${campaignCode}`}
      className={clsx(styles.main, className)}
    >
      <div className={styles.top}>
        <div>
          {chips != null && chips.length > 0 && (
            <div className={styles.chips}>
              {chips.map((chipProps: JobCardChipProps) => (
                <JobCardChip
                  key={uuidv4()}
                  {...chipProps}
                  className={clsx(styles.chip, chipProps.className)}
                />
              ))}
            </div>
          )}
        </div>
        <EmailAndFavoriteIcons
          showContactAction={showContactAction}
          showFavoriteAction={showFavoriteAction}
          recommended={recommended}
          isRecommendedJobsOnResult={isRecommendedJobsOnResult}
          sourceType={sourceType}
          campaignCode={campaignCode}
          job={job}
          viewMyJobs={viewMyJobs}
          similarOrViewed={similarOrViewed}
          onEmailClick={onEmailClick}
          modifyJob={modifyJob}
        />
      </div>

      <img
        src={image}
        alt={`${job.city}, ${job.state}`}
        className={styles.image}
        onError={() => {
          setIsImageBroken(true);
        }}
      />
    </div>
  );
};

JobCardHeader.defaultProps = {
  job: undefined,
  chips: [],
  showContactAction: true,
  showFavoriteAction: true,
  isRecommendedJobsOnResult: false,
  recommended: false,
  similarOrViewed: "",
  viewMyJobs: false,
  className: "",
  onClick: undefined,
  modifyJob:undefined
};

const mapStateToProps = (state) => ({
  emailSuccess: state.emailRecruiter.emailSuccess,
  emailSuccessResponse: state.emailRecruiter.emailSuccessResponse,
  error: state.emailRecruiter.error,
  jobFavoriteSuccess: state.applyFavEmail.jobFavoriteSuccess,
  allJobs: state.jobResults.jobs,
  similarJobs: state.jobDetails.similarJobsCarouselItems,
  collaboratedJobs: state.jobDetails.collaboratedJobsCarouselItems,
  recommendedJobs: state.jobs.recommendedJobs,
  jobDetails: state.jobDetails.jobDetails,
  myJobs: state.myJobs.myJobs,
  filteredJobs: state.myJobs.filteredJobs,
  actionJobId: state.emailRecruiter.actionJobId,
});

const mapDispatchToProps = (dispatch) => ({
  postTheJobApplicationFavoriteEmail: (reqObj) => dispatch(postJobApplicationFavoriteEmail(reqObj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(JobCardHeader));
